import React, { useEffect, useRef } from 'react';
import { StyledCircleFollow } from './StyledCircleFollow';
import { gsap } from "gsap";

import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

const CircleFollow = () => {
  const lineRef = useRef(null);
  const circleRef = useRef(null);
  useEffect(()=>{
    gsap.to(lineRef.current,{
      scrollTrigger: {
        trigger: lineRef.current,
        start: "center center",
        pin: true,
        endTrigger: ".line-end-trigger",
        end: "bottom bottom"
      }
    })
    gsap.to(circleRef.current,{
      scrollTrigger: {
        trigger: circleRef.current,
        start: "top center",
        pin: true,
        endTrigger: ".line-end-trigger",
        end: "bottom center"
      }
    })
  },[])
  return (
    <React.Fragment>
      {
       
          <StyledCircleFollow>
            <div ref={lineRef} className="line-back"></div>
            <div ref={circleRef} className="circle-follow"></div>
          </StyledCircleFollow>
          
      }
    </React.Fragment>
  );
};


export default CircleFollow;
